var _circle, _circle2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightDiversion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 254 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 127,
    r: 127,
    fill: "#1F4B82"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 126,
    r: 117,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2209 80.1481C110.221 99.1481 125.648 119.648 128.221 220.148",
    stroke: "#940D15",
    strokeWidth: 18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.148 80.1481C141.148 99.1481 120.148 118.648 123.148 220.148",
    stroke: "white",
    strokeWidth: 18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.148 80.1481C147.148 99.1481 126.148 118.648 129.148 220.148",
    stroke: "#940D15",
    strokeWidth: 18
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.903 58.0114L157.027 53.3179L206.561 119.635L219.903 58.0114Z",
    fill: "#940D15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3214 64.2866L97.1401 51.8811L56.1552 123.796L35.3214 64.2866Z",
    fill: "#940D15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDiversion);
export default __webpack_public_path__ + "static/media/flight_diversion.09972636b16437ede2c52e16cd93af70.svg";
export { ForwardRef as ReactComponent };